import React, { useEffect, useState } from "react";
import { Spinner } from "reactstrap";
import { bootstrapAdminDataSource, getAdminBootstrapState } from "data/admin/bootstrapAdminData";

/**
 * Admin veri kaynağı (Firebase/localStorage) hazır olana kadar çocukları bekletir.
 */
export default function AdminDataGate({ children }) {
  const [ready, setReady] = useState(getAdminBootstrapState().ready);
  const [error, setError] = useState(getAdminBootstrapState().error);

  useEffect(() => {
    let cancelled = false;
    bootstrapAdminDataSource().then((state) => {
      if (cancelled) return;
      setError(state.error);
      setReady(true);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  if (!ready) {
    return (
      <div
        className="d-flex flex-column align-items-center justify-content-center"
        style={{ minHeight: "100vh", background: "#f7fafc" }}
      >
        <Spinner color="primary" />
        <div className="text-muted mt-3 small">Yönetim verileri yükleniyor…</div>
      </div>
    );
  }

  return (
    <>
      {error ? (
        <div className="alert alert-warning mb-0 rounded-0 text-center small py-2">
          Firebase’e bağlanılamadı, yerel depolama kullanılıyor: {error}
        </div>
      ) : null}
      {children}
    </>
  );
}
